import { render, staticRenderFns } from "./Domains.vue?vue&type=template&id=b3eabdb8&scoped=true&"
import script from "./Domains.vue?vue&type=script&lang=js&"
export * from "./Domains.vue?vue&type=script&lang=js&"
import style0 from "./Domains.vue?vue&type=style&index=0&id=b3eabdb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3eabdb8",
  null
  
)

export default component.exports